import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import Component from "./Node.vue";
import { createDefaultBlockForTipTap } from "~/stores/mail-block-editor/defaults";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        paragraph: {
            /**
             * Set a heading node
             * @param attributes The heading attributes
             * @example editor.commands.setParagraph()
             */
            setParagraph: () => ReturnType;
            /**
             * Toggle a heading node
             * @param attributes The heading attributes
             * @example editor.commands.toggleParagraph()
             */
            toggleParagraph: () => ReturnType;
        };
    }
}

const Paragraph = Node.create({
    name: "paragraph",
    group: "block",
    content: "inline*",
    priority: 1000,

    addAttributes() {
        return createDefaultBlockForTipTap("paragraph");
    },

    parseHTML() {
        return [
            {
                tag: "p",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["p", mergeAttributes(HTMLAttributes), 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(Component as Parameters<typeof VueNodeViewRenderer>[0]);
    },

    addCommands() {
        return {
            setParagraph:
                () =>
                ({ commands }) => {
                    return commands.setNode(this.name);
                },
            toggleParagraph:
                () =>
                ({ commands }) => {
                    const store = useMailStore();

                    return commands.toggleNode(
                        this.name,
                        "paragraph",
                        useCloneDeep(store.currentBlock?.attrs ?? {}),
                    );
                },
        };
    },

    addKeyboardShortcuts() {
        return {
            "Mod-Alt-0": () => this.editor.commands.toggleParagraph(),
        };
    },
});

export default Paragraph;
